/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_Who_TitleInputs */

const en_fc_vs_who_title = /** @type {(inputs: Fc_Vs_Who_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who should choose which?`)
};

/**
* | output |
* | --- |
* | "Who should choose which?" |
*
* @param {Fc_Vs_Who_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_who_title = /** @type {((inputs?: Fc_Vs_Who_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Who_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_who_title(inputs)
});
export { fc_vs_who_title as "fc.vs.who.title" }